import angular from 'angular';
import RunnerFlowsSearchBridge from './RunnerFlowsSearchBridge';

angular
  .module('flowingly.runner.flows.search')
  .component('runnerFlowsSearch', RunnerFlowsSearchBridge);
